export default __webpack_public_path__ + "static/media/icon-bell-white.39865adf.svg";